import React from 'react'
import InlineLoader from 'modules/common/components/inlineloader'

const PageLoading = ({isLoading, error}) => {
  if (isLoading) {
    return <InlineLoader className="loader--big" />
  }
  else if (error) {
    return <div style={{padding: '40px 20px', textAlign: 'center'}}>Sorry, there was a problem loading the page.</div>;
  }
  else {
    return null;
  }
};

export default PageLoading



// WEBPACK FOOTER //
// ./src/modules/common/components/pageloading/PageLoading.js